import { FormTextField } from "@elements/Inputs"
import { PositionedTopProgress } from "@elements/Loaders"
import styled from "@emotion/styled"
import useLoading from "@hooks/useLoading"
import useTrigger from "@hooks/useTrigger"
import { ButtonBase, InputAdornment } from "@mui/material"
import { colors, fontSize, size } from "@styles/theme"
import axios from "@utils/webRequests"
import { useEffect, useState } from "react"
import { PiAtBold, PiCaretLeftBold, } from "react-icons/pi"
import { useNavigate } from "react-router-dom"
import snakecaseKeys from "snakecase-keys"

const backgroundArr = [
  // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668977/we-vibe-toys-zMgOtCkeBUg-unsplash.jpg',
  // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668981/alora-griffiths-bW-BZekV2Dk-unsplash.jpg',
  'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668988/sasha-lebedeva-W4_2-V666Wo-unsplash.jpg',
  // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668989/logan-weaver-lgnwvr-s8Y0yMrfhAk-unsplash.jpg',
]

const DisplayNameHandleForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
`

const Title = styled.h2`
  padding: 0;
  margin: 0;
  margin-bottom: ${size(5.5)};
  margin-top: ${size(3)};
  font-size: ${fontSize('xl')};
`

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: ${size(2.5)};
`

const ActionButton = styled(ButtonBase)`
  padding: ${size(2)};
  border-radius: 100px;

  font-weight: 500;
  font-size: ${fontSize('md')};

  box-shadow: 0px 2px 8px 2px rgba(13, 64, 115, 0.70);
  background: linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%);
`

const BackButton = styled(ActionButton)`
  border: 1px solid grey;
  background: none;
  box-shadow: none;
`

const HandleGenerateText = styled.u`
  display: flex;
  align-items: center;
  margin-right: ${size(0.5)};
  color: ${colors.statusColors.chatting('light')};
`

const textFieldLabelProps = {
  style: { width: '100%' }
}

const textFieldInputStyles = {
  // backgroundColor: 'black',
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: '100px',
  '&fieldset': {
    borderRadius: '100px',
  }
}

const RegisterModalDisplayNameHandle = ({ formState, setHandleErrors, formErrors, handleChange, setHandle, actionHandler, isLoading, isLoadingDelayed }) => {
  const navigate = useNavigate()
  const { isLoading: isHandleLoading, setIsLoading: setIsHandleLoading, isLoadingDelayed: isHandleLoadingDelayed } = useLoading()
  const [isHandleValid, setIsHandleValid] = useState(false)

  // generates a user handle on component mount
  useEffect(() => {
    if (!formState?.handle) {
      genHandle()
    }
  }, [])

  useTrigger(formState?.handle, 500, () => {
    if (formState.handle) {
      validateUserHandle()
    } else {
      setIsHandleValid(false)
    }
  })

  const validateUserHandle = () => {
    axios.post(`/api/auth/account_validations`, snakecaseKeys(formState))
      .then((res) => {
        let handleErrors = res.data?.handle
        if (!handleErrors) {
          setIsHandleValid(true)
          setHandleErrors(null)
        } else {
          setIsHandleValid(false)
          setHandleErrors(handleErrors)
        }
    })
    .catch(console.log)
  }

  const genHandle = () => {
    if (isHandleLoading) return;
    setIsHandleLoading(true)
    axios.get('/api/auth/generate_handles')
      .then((res) => {
        setIsHandleLoading(false)
        setHandle(res.data)
      })
      .catch((err) => {
        console.log(err?.response?.data?.errors)
        setIsHandleLoading(false)
      })
  }

  const renderRandomHandleButton = () => (
    <ButtonBase
      onClick={genHandle}
      style={{ position: 'absolute', top: 0, right: 0 }}>
      <HandleGenerateText>
        {isHandleLoadingDelayed ? 'randomizing' : 'randomize'}
      </HandleGenerateText>
    </ButtonBase>
  )

  const handleInnerAction = (e) => {
    if (isLoading) return;
    actionHandler(e)
  }

  const renderHandleAvailableText = () => (
    <span style={{ color: colors.success(500) }}>handle available</span>
  )

  const renderHandleHelperText = () => {
    if (isHandleValid && !formErrors?.handle) {
      return renderHandleAvailableText()
    } else if (formErrors?.handle?.[0]) {
      return formErrors?.handle?.[0]
    } else {
      return ' '
    }
  }

  return (
    <DisplayNameHandleForm onSubmit={handleInnerAction}>
      <PositionedTopProgress isLoadingDelayed={isLoadingDelayed} />
      <Title>What will you go by?</Title>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <FormTextField
          name='displayName'
          label='Display Name'
          value={formState?.displayName}
          onChange={handleChange}
          placeholder='ex) Handsome Hero, Funguy, etc'
          error={formErrors?.displayName}
          helperText={formErrors?.displayName?.[0]}
          labelProps={textFieldLabelProps}
          slotProps={{ input: {
            style: textFieldInputStyles,
          }}}
        />
        <div style={{ position: 'relative', width: '100%' }}>
          {renderRandomHandleButton()}
          <FormTextField
            name='handle'
            label='User Handle'
            value={formState?.handle}
            onChange={handleChange}
            placeholder='Text to reference you'
            error={formErrors?.handle}
            helperText={renderHandleHelperText()}
            labelProps={textFieldLabelProps}
            slotProps={{ input: {
              style: textFieldInputStyles,
              startAdornment: (
                <InputAdornment position="start">
                  <PiAtBold fill='white' />
                </InputAdornment>
              ),
            }}}
          />
        </div>
      </div>
      <ButtonArea>
        <BackButton
          style={{ flexGrow: 0.5, background: 'none', boxShadow: 'none' }}
          onClick={() => navigate(-1)}>
          <PiCaretLeftBold />
          Back
        </BackButton>
        &nbsp;
        <ActionButton
          style={{ flexGrow: 4 }}
          type='submit'>
          {isLoading ? 'Loading...' : 'Submit' }
        </ActionButton>
      </ButtonArea>
    </DisplayNameHandleForm>
  )
}

export default RegisterModalDisplayNameHandle
